import {
  PAGE_TYPES,
  sanitizeCollectionName,
  truncatePageNameParts,
  type PageType,
} from '@wix/wix-data-client-common'

type Params = {
  collectionName: string
  pageType: PageType
}

export const buildPageName = ({ collectionName, pageType }: Params): string => {
  const name = sanitizeCollectionName(collectionName)
  const suffix = pageType === PAGE_TYPES.ITEM ? 'item' : 'list'

  const { truncatedName, truncatedSuffix } = truncatePageNameParts({
    name,
    suffix,
  })
  return `${truncatedName} ${truncatedSuffix}`
}
